export default "__VITE_ASSET__DUmyYyF6__"